import React, { useEffect, useState } from 'react';
import { FaStar, FaCrown, FaTriangleExclamation, FaArrowRight, FaReceipt } from 'react-icons/fa6';
import MiniLoadingSpinner from '../../../../../../components/Spinners/MiniLoadingSpinner';
import { ClientReview, UserMap } from '../../types';
import { getPaymentReceiptById } from '../../../../../../crud/payments_api/payment_receipts';
import ReceiptDetails from 'views/Restaurant/Caja/Receipts/components/Table/components/ReceiptDetails/ReceiptDetails';
import { toast } from 'react-toastify';
import './ReviewsList.scss';

interface Props {
  reviews: ClientReview[];
  userMap: UserMap;
}

const ReviewsList: React.FC<Props> = ({ reviews, userMap }) => {
  const [ready, setReady] = useState(false);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [currentReceipt, setCurrentReceipt] = useState<any>(null);
  const [loadingReceipt, setLoadingReceipt] = useState(false);

  useEffect(() => {
    setReady(true);
  }, [reviews]);

  const handleOpenReceipt = async (receiptId: number, e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent card flip
    setLoadingReceipt(true);
    try {
      const response = await getPaymentReceiptById(receiptId);
      if (response.data) {
        setCurrentReceipt(response.data);
        setShowReceiptModal(true);
      } else {
        toast.error('No se encontró el recibo');
      }
    } catch (error) {
      console.error('Error fetching receipt:', error);
      toast.error('Error al cargar el recibo');
    } finally {
      setLoadingReceipt(false);
    }
  };

  const handleCloseReceiptModal = () => {
    setShowReceiptModal(false);
    setTimeout(() => setCurrentReceipt(null), 100);
  };

  if (!ready) return <MiniLoadingSpinner />;

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) =>
      i < rating ? (
        <FaStar key={i} className="star-icon filled" />
      ) : (
        <FaStar key={i} className="star-icon empty" />
      )
    );
  };

  function getFirstLetter(str: string) {
    if (!str || str.length === 0) return 'N/A';
    return str.charAt(0).toUpperCase();
  }

  const renderCommentSection = (comment: string | null) => {
    const LIMIT = 30;
    function getCommentBrief(comment: string | null) {
      if (!comment) return ;
      if (comment.length > LIMIT) {
        return comment.slice(0, LIMIT) + '...';
      }
      return comment;
    }

    return (
      <div className='comment-brief-section'>
        <p className="comment-brief">
          {getCommentBrief(comment)}
          {comment && comment.length > LIMIT && (
              <FaArrowRight className='arrow-icon' />
          )}
        </p>
      </div>
    )
  }

  

  return (
    <div className="reviews-list">
      {reviews.map(r => (
        <div key={r.receipt_id} className="review-card">
          <div className="card-inner">
            {/* Front Face */}
            <div className="card-face card-front">
              <div className="header">
                <span className="avatar">{getFirstLetter(userMap[r.user_id])}</span>
                <span className="avatar-name">{userMap[r.user_id] || `N/A`}</span>
              </div>
              <div className="body">
                <span className="date">{r.timestamp.slice(0, 16)}</span>
                <div>
                <span className="stars">{renderStars(r.object.amabilidad.rating)}</span>
                  <span className="rating-label">Servicio</span>
                  
                </div>
                <div>
                <span className="stars">{renderStars(r.object.sabor.rating)}</span>
                  <span className="rating-label">Sabor</span>
                  
                </div>
                <div>
                <span className="stars">{renderStars(r.object.experiencia.rating)}</span>
                  <span className="rating-label">Experiencia</span>
                  
                </div>
                {r.object.sabor.favorite && (
                  <div className="favworst fav">
                    <FaCrown className='review-icon'/>{r.object.sabor.favorite.item_name}
                  </div>
                )}
                {r.object.sabor.worst && (
                  <div className="favworst worst">
                    <FaTriangleExclamation className='review-icon'/> {r.object.sabor.worst.item_name}
                  </div>
                )}
              </div>
              <div className="footer">
                <div className='comment-briefs-section'>
                {r.object.amabilidad.comment ? r.object.amabilidad.comment && renderCommentSection(r.object.amabilidad.comment)
                : (<>{
                  r.object.sabor.comment ? renderCommentSection(r.object.sabor.comment)
                : (
                  r.object.experiencia.comment && renderCommentSection(r.object.experiencia.comment)
                )}
                  </>)
              }
                </div>
                </div>
            </div>

            {/* Back Face */}
            <div className="card-face card-back">
              <h4>Comentarios</h4>
              <div className="comments">
                {r.object.amabilidad.comment && (
                  <p className="comment">“{r.object.amabilidad.comment}”</p>
                )}
                {r.object.sabor.comment && (
                  <p className="comment">“{r.object.sabor.comment}”</p>
                )}
                {r.object.experiencia.comment && (
                  <p className="comment">“{r.object.experiencia.comment}”</p>
                )}
                {!r.object.amabilidad.comment &&
                  !r.object.sabor.comment &&
                  !r.object.experiencia.comment && (
                    <p className="no-comment">Sin comentarios</p>
                  )}
              </div>
              <button 
                className="view-receipt-btn"
                onClick={(e) => handleOpenReceipt(r.receipt_id, e)}
                disabled={loadingReceipt}
              >
                <FaReceipt /> Ver Recibo
              </button>
            </div>
          </div>
        </div>
      ))}

      {/* Receipt Details Modal */}
      <ReceiptDetails
        key={currentReceipt?.receipt_id || 'no-receipt'}
        setReceipts={() => {}}
        currentReceipt={currentReceipt}
        show={showReceiptModal}
        onClose={handleCloseReceiptModal}
      />
    </div>
  );
};

export default ReviewsList;
